export default {
  exampleRoute: {
    title: 'Jämför och hitta billigast lån, elpriser och försäkringar | Zmarta',
    description: 'Jämför lån, elpriser och försäkringar på zmarta.se för att hitta det billigaste erbjudandet på nätet! Vi hjälper dig att hitta bäst alternativ för just dina behov och pengar.',
    keywords: '',
    canonical: '/example-route',
    robots: 'noindex, nofollow'
  }
}
